// cache-bust
import { createRoot } from 'react-dom/client';
import './locales/i18n';
// import './style.css';
import './pixis-style.css';
import './mobile.css';
import { ApiErrorBoundaryProvider } from './hooks/ApiErrorBoundaryContext';
import 'katex/dist/katex.min.css';
import 'katex/dist/contrib/copy-tex.js';
import PixisApp from '~/PixisApp.js';

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <ApiErrorBoundaryProvider>
    <PixisApp />
  </ApiErrorBoundaryProvider>,
);
